import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import image2 from '@/assets/images/subscription/2.webp';
import image2Mobile from '@/assets/images/subscription/2m.webp';
import image3 from '@/assets/images/subscription/3.webp';
import image3Mobile from '@/assets/images/subscription/3m.webp';
import image4 from '@/assets/images/subscription/4.webp';
import image4Mobile from '@/assets/images/subscription/4m.webp';
import image5 from '@/assets/images/subscription/5.webp';
import image5Mobile from '@/assets/images/subscription/5m.webp';
import { Button } from '@/components/Button';
import { FeatureSection } from '@/pages/Subscription/Intro/FeatureSection';
import { useStatusCard } from '@/pages/Subscription/hooks/useStatusCard';
import { ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS } from '@/router/routes';
import { BorderRadius, ButtonVariant, Size } from '@/types/components';

export const Features: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { canPurchase } = useStatusCard();

  return (
    <div className="rounded-t-2xl bg-card px-4 pb-10 md:px-16">
      <div className="divide-y divide-divider">
        <FeatureSection
          title={t('subscription.intro.features.ratingsTitle')}
          description={t('subscription.intro.features.ratingsDescription')}
          image={image2}
          mobileImage={image2Mobile}
        />
        <FeatureSection
          title={t('subscription.intro.features.pushTitle')}
          description={t('subscription.intro.features.pushDescription')}
          image={image3}
          mobileImage={image3Mobile}
          imageOnLeft
        />
        <FeatureSection
          title={t('subscription.intro.features.channelsTitle')}
          description={t('subscription.intro.features.channelsDescription')}
          image={image4}
          mobileImage={image4Mobile}
        />
        <FeatureSection
          title={t('subscription.intro.features.homeTitle')}
          description={t('subscription.intro.features.homeDescription')}
          image={image5}
          mobileImage={image5Mobile}
          imageOnLeft
        />
      </div>
      <div className="flex justify-center pt-6">
        <Button
          variant={ButtonVariant.Primary}
          size={Size.Medium}
          radius={BorderRadius.Pill}
          disabled={!canPurchase}
          onClick={() => navigate(ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS)}
        >
          {t('subscription.intro.activeButton')}
        </Button>
      </div>
    </div>
  );
};
